import type { TrafikverketSourceOptions } from './Sources.types';
import { TrafikverketSource } from './TrafikverketSource';

const defaultOptions = (region: string): TrafikverketSourceOptions => ({
    id: 'road-condition-status-source',
    showErrorToast: false,
    objectType: 'RoadCondition',
    schemaVersion: '1.2',
    query: `
        <FILTER>
            <AND>
                <IN name="CountyNo" value="${region === 'vst' ? '1' : '13,14'}" />
            </AND>
        </FILTER>
        <INCLUDE>Id</INCLUDE>
        <INCLUDE>Cause</INCLUDE>
        <INCLUDE>ConditionCode</INCLUDE>
        <INCLUDE>ConditionText</INCLUDE>
        <INCLUDE>ConditionInfo</INCLUDE>
        <INCLUDE>StartTime</INCLUDE>
        <INCLUDE>EndTime</INCLUDE>
        <INCLUDE>ModifiedTime</INCLUDE>
        <INCLUDE>Measurement</INCLUDE>
        <INCLUDE>Warning</INCLUDE>
    `,
});

export class RoadConditionStatusSource extends TrafikverketSource {
    constructor(region: string, options?: Partial<TrafikverketSourceOptions>) {
        super({ ...defaultOptions(region), ...options });
    }
}
